<template>
  <div>
    <div class="prev modal-nav-btn" @click="iterateItem('-')" v-if="currentItemIndex !== 0" :title="prevBtnTitle">
      <icon name="chevron-left"></icon>
    </div>
    <div class="next modal-nav-btn" @click="iterateItem('+')" :title="nextBtnTitle"
         v-if="currentItemIndex < listData.length - 1">
      <icon name="chevron-right"></icon>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      listData: {
        type: Array,
        required: true,
      },
      currentItemIndex: {
        type: Number,
        default: 0
      },
      closeModalEventName: {
        type: String,
        required: true
      },
      saveCurrentItemEventName: {
        type: String
      },
      iterateCallBack: {
        type: Function,
        required: true
      },
      prevBtnTitle: {
        type: String,
        default: ''
      },
      nextBtnTitle: {
        type: String,
        default: ''
      }
    },
    methods: {
      iterateItem(type) {
        const currentIndex = this.currentItemIndex;
        const index = type === '+' ? currentIndex + 1 : currentIndex - 1;
        this.$root.$emit(this.closeModalEventName);
        this.$nextTick(() => {
          const itemId = this.listData[index].id;
          this.iterateCallBack(itemId);
        });
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/common/ModalNavs.vue